import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import TextArea from 'web/components/form-elements/TextArea';
import './yesNoModal.scss';

export default ({ isOpen,
  toggle, 
  title, 
  content, 
  link, 
  onClickHander,
  type, 
  enableConfirmationComment = false, 
  confirmationCommentBoxLabel,
  confirmationComment = '', 
  setconfirmationComment = () => {} 
}) => {
  let history = useHistory();

  const redirectLink = (link) => {
    if (link === 'manageAccount') {
      window.location.reload(false);
    } else {
      if (link !== '/') {
        history.push(link);
      }
    }
    toggle(!isOpen)
  }
  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='next-step-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              if (link === 'manageAccount') {
                window.location.reload(false);
              }
              onClickHander('no')
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className={`modal-content ${enableConfirmationComment ? 'text-left' : ''}`}>
              {type === 'inventory' ?
                <p>{content}</p>
                :
              <p className='my-2 mb-4'>{content}</p>
              }
            </div>
            {enableConfirmationComment && <div className="app-input-text text-left" style={{ width: "100%" }}>
              <label className='text-left font-weight-bold'>{confirmationCommentBoxLabel}</label>
              <textarea
                name='comment'
                maxLength='200'
                showErrorMessages={true}
                value={confirmationComment}
                onChange={e => setconfirmationComment(e.target.value)}
                className="text-left"
              />
            </div>
            }
          </ModalBody>
          <ModalFooter className='modal-footer'>
            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                toggle(!isOpen)
                onClickHander('no')
              }}>
              No
            </Button>
            <Button
              type='app-green-button'
              handleClick={() => {
                if(type !== 'inventory')
                redirectLink(link)
                onClickHander()
              }}>
              Yes
            </Button>

          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
